import { getClientsList, getClientData } from '@/api/toB'
import router from '@/router'

const state = () => ({
  cid: '',
  clientInfo: {},
  clientToken: '',
  clientId: '',
  clientTitle: '',
  clientDescription: '',
  clientIntroduction: '',
  clientIcon: null,
  clientAssets: [],
  clientBanners: [],
  clientCategories: [],
  clientCourses: [],
  borrowRecord: [],
  clientsQRCode: '',
  isLoading: true,
  isCanBorrow: false,
  borrowErrorText: ''
})

const mutations = {
  setCID: (state, cid) => {
    state.cid = cid
  },
  setClientInfo: (state, info) => {
    state.clientInfo = info
  },
  setClientToken: (state, token) => {
    state.clientToken = token
  },
  setClientData: (state, data) => {
    state.clientTitle = data.display_name
    state.clientDescription = data.description
    state.clientIntroduction = data.introduction
    state.clientIcon = data.icon
    state.clientAssets = data.client_blocks[0].client_assets
    state.clientBanners = data.client_banners
    state.clientCategories = data.categories

    const coursesIdList = data.client_blocks[0].client_assets.map((clientAsset) => {
      return clientAsset.channel.id
    })
    state.clientCourses = coursesIdList
  },
  CLIENTS_TITLE: (state, title) => {
    state.clientTitle = title
  },
  CLIENTS_DESCRIPTION: (state, description) => {
    state.clientDescription = description
  },
  CLIENTS_ASSETS: (state, assets) => {
    state.clientAssets = assets

    const coursesIdList = assets.map((clientAsset) => {
      return clientAsset.channel.id
    })
    console.log(coursesIdList)
    state.clientCourses = coursesIdList
  },
  CLIENTS_QRCODE: (state, QRCode) => {
    state.clientsQRCode = QRCode
  },
  setBorrowRecord: (state, record) => {
    state.borrowRecord = record
  },
  setIsLoading: (state, status) => {
    state.isLoading = status
  },
  setIsCanBorrow: (state, status) => {
    state.isCanBorrow = status
  },
  setBorrowErrorText: (state, text) => {
    state.borrowErrorText = text
  }
}

const actions = {
  setCID ({ commit }, cid) {
    commit('setCID', cid)
  },
  setBorrowRecord ({ commit }, record) {
    commit('setBorrowRecord', record)
  },
  setClientToken ({ commit }, token) {
    commit('setClientToken', token)
  },
  setBorrowErrorText ({ commit }, text) {
    commit('setBorrowErrorText', text)
  },
  getClientInfo ({ commit }, cid) {
    return getClientsList()
      .then((res) => {
        const clientsData = res.data.clients

        const findClient = clientsData.filter(client => client.cid === cid)
        commit('setClientInfo', findClient[0])
        return findClient[0]
      })
      .catch(error => console.log('log:' + error))
  },
  fetchClientData ({ commit }, cid) {
    return getClientData(cid)
      .then((res) => {
        // console.log(res)
        commit('setClientData', res.data)
      })
      .catch((err) => {
        console.log(err.response)
        if (err.response.status === 404) {
          router.push('/')
        }
      })
  }
}

const getters = {
  clientsLogo: state => {
    return '' || state.clientInfo.logo
  }
  // clientTitle: state => {
  //   return state.clientTitle
  // },
  // clientLogo: state => {
  //   return state.clientLogo
  // },
  // clientDescription: state => {
  //   return state.clientDescription
  // },
  // clientAssets: state => {
  //   return state.clientAssets
  // },
  // clientCourses: state => {
  //   return state.clientCourses
  // },
  // clientsQRCode: state => {
  //   return state.clientsQRCode
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/toB.js